module.exports = __webpack_public_path__ + "img/mllogo.18eb8218.png";